export function isUntaggedPort(vlanrange: string | null | undefined): boolean {
  return !vlanrange || vlanrange === "0";
}
